import React from 'react';

interface Props {
    className?: string;
    width?: number;
    height?: number;
}

const ErrorOutline: React.FC<Props> = ({ className, width = 48, height = 48 }) => (
    <svg
        width={width}
        height={height}
        className={className}
        viewBox='0 0 48 48'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M21.9998 30H25.9998V34H21.9998V30ZM21.9998 13.9999H25.9998V25.9999H21.9998V13.9999ZM23.9798 3.99994C12.9398 3.99994 3.99976 12.9599 3.99976 23.9999C3.99976 35.0399 12.9398 43.9999 23.9798 43.9999C35.0398 43.9999 43.9998 35.0399 43.9998 23.9999C43.9998 12.9599 35.0398 3.99994 23.9798 3.99994ZM23.9995 39.9999C15.1595 39.9999 7.99951 32.8399 7.99951 23.9999C7.99951 15.1599 15.1595 7.99988 23.9995 7.99988C32.8395 7.99988 39.9995 15.1599 39.9995 23.9999C39.9995 32.8399 32.8395 39.9999 23.9995 39.9999Z'
            fill='#FBF433'
        />
    </svg>
);

export default ErrorOutline;
